module.exports = __webpack_public_path__ + "static/media/dot-blue.a3ef7630.svg";